// src/controllers/tattoo_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    window.print();
  }
}
